module.exports = __webpack_public_path__ + "img/pixielogo.c25c4827.png";